import { render } from "./search-no-results.vue?vue&type=template&id=12d4ff7a"
import script from "./search-no-results.vue?vue&type=script&lang=js"
export * from "./search-no-results.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__